<template>
  <swiper-slide tag="li">
    <slot />
  </swiper-slide>
</template>
<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue';
</script>
<style lang="scss" scoped>
.swiper-slide {
  width: unset;
}
</style>
